var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.086 12.002-7.182 7.182-.99-.972 6.21-6.21-6.21-6.21.99-.972 7.182 7.182Z",
    fill: "#000"
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNi4wODYxIDEyLjAwMThMOC45MDQwNiAxOS4xODM4TDcuOTE0MDYgMTguMjExOEwxNC4xMjQxIDEyLjAwMThMNy45MTQwNiA1Ljc5MTgyTDguOTA0MDYgNC44MTk4MkwxNi4wODYxIDEyLjAwMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";